import { render, staticRenderFns } from "./StudentListRow.vue?vue&type=template&id=585b266e&scoped=true&"
import script from "./StudentListRow.vue?vue&type=script&lang=js&"
export * from "./StudentListRow.vue?vue&type=script&lang=js&"
import style0 from "./StudentListRow.vue?vue&type=style&index=0&id=585b266e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b266e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/maplebear-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VDivider,VIcon,VListTile,VListTileAvatar,VListTileContent,VListTileSubTitle,VListTileTitle})
